import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MainMenuComponent} from '../../components/main-menu/main-menu.component';
import {IonicModule} from '@ionic/angular';
import {RefresherComponent} from '../../components/refresher/refresher.component';
import {PageTopToolbarComponent} from '../../components/page-top-toolbar/page-top-toolbar.component';
import {NotificationsPopoverComponent} from '../../components/notifications-popover/notifications-popover.component';
import {SafePipe} from '../../pipes/safe.pipe';
import {DataGridComponent} from "../../components/data-grid/data-grid.component";
import {EditUserComponent} from "../../components/edit-user/edit-user.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {AddUserComponent} from "../../components/add-user/add-user.component";
import {CameraComponent} from "../../components/twilio/camera/camera.component";
import {TwilioHomeComponent} from "../../components/twilio/twilio-home/twilio-home.component";
import {ParticipantsComponent} from "../../components/twilio/participants/participants.component";
import {RoomsComponent} from "../../components/twilio/rooms/rooms.component";
import {SettingsComponent} from "../../components/twilio/settings/settings.component";
import {DeviceSelectComponent} from "../../components/twilio/settings/device-select.component";
import {ChangeComponent} from "../../components/change/change.component";
import {FilesPreviewComponent} from "../../components/files-preview/files-preview.component";
import {
  FilesDetailsPreviewerComponent
} from "../../components/files-details-previewer/files-details-previewer.component";
import {
  DataGridActionButtonsMenuComponent
} from "../../components/data-grid/data-grid-action-buttons-menu/data-grid-action-buttons-menu.component";
import {TranslateModule} from "@ngx-translate/core";
import {EditClientComponent} from "../../components/edit-client/edit-client.component";
import {EditLeadComponent} from "../../components/edit-lead/edit-lead.component";
import {LeadAgreementComponent} from "../../components/lead-agreement/lead-agreement.component";
import {TranslationPipe} from 'src/app/pipes/translation.pipe';
import {EditPartnerComponent} from "../../components/edit-partner/edit-partner.component";
import {VImageDropComponent} from "../../components/v-image-drop/v-image-drop.component";
import {NgxDropzoneModule} from "ngx-dropzone";
import {OrderDetailsComponent} from "../../components/order-details/order-details.component";
import {ImportClinicComponent} from "../../components/import-clinic/import-clinic.component";
import {
  ProcessSettlementReportComponent
} from "../../components/process-settlement-report/process-settlement-report.component";
import {EditPartnerBannerComponent} from "../../components/edit-partner-banner/edit-partner-banner.component";
import {VMessageComponent} from "../../components/v-message/v-message.component";
import {SelectClientComponent} from "../../components/select-client/select-client.component";
import {
  OrderSettlementItemsListComponent
} from "../../components/order-settlement-items-list/order-settlement-items-list.component";
import {VetineoHeaderComponent} from "../../components/vetineo-header/vetineo-header.component";
import {TranslateOfferType} from "../../pipes/translate-offer-type.pipe";
import {GenerateTermsComponent} from "../../components/generate-terms/generate-terms.component";
import {TermPlaceholderComponent} from "../../components/term-placeholder/term-placeholder.component";
import {RefundDetailsComponent} from "../../components/refund-detils/refund-details.component";
import {
  SettlementItemDetailsComponent
} from "../../components/settlement-item-details/settlement-item-details.component";
import {
  AddP24RegistrationDataComponent
} from "../../components/add-p24-registration-data/add-p24-registration-data.component";
import {NotFoundDataComponent} from "../../components/not-found-data/not-found-data.component";
import {ResetPwdComponent} from "../../components/reset-pwd/reset-pwd.component";
import {ClinicInfoEditComponent} from "../../components/clinic-info-edit/clinic-info-edit.component";
import {ClinicTeamEditComponent} from "../../components/clinic-team-edit/clinic-team-edit.component";
import {ClinicTimetableEditComponent} from "../../components/clinic-timetable-edit/clinic-timetable-edit.component";
import {VImageEditorComponent} from "../../components/v-image-editor/v-image-editor.component";
import {VImageManagerComponent} from "../../components/v-image-manager/v-image-manager.component";
import {VetDoctorDataEditorComponent} from "../../components/vet-doctor-data-editor/vet-doctor-data-editor.component";
import {
  ReservationJsonElementComponent
} from "../../components/reservation-json-element/reservation-json-element.component";
import {
  ListReservationJsonElementComponent
} from "../../components/list-reservation-json-element/list-reservation-json-element.component";
import {
  KlinikaxpPaymentModalComponent
} from "../../components/klinikaxp-payment-modal/klinikaxp-payment-modal.component";
import {LabDataEditComponent} from "../../components/lab-data-edit/lab-data-edit.component";
import {AcceptRefundComponent} from "../../components/accept-refund/accept-refund.component";
import {ComponentTitleComponent} from "../../components/component-title/component-title.component";
import {FillPipe} from "../../pipes/fill.pipe";
import {
  EditNextVisitReminderSettingsComponent
} from "../../components/edit-next-visit-reminder-settings/edit-next-visit-reminder-settings.component";
import {SelectYearAndMonthComponent} from "../../components/select-year-and-month/select-year-and-month.component";
import {
  NextVisitReminderVisitTypeComponent
} from "../../components/next-visit-reminder-visit-type/next-visit-reminder-visit-type.component";
import {RemindersForUserComponent} from "../../components/reminders-for-user/reminders-for-user.component";
import {WidgetInfoComponent} from "../../components/widget-info/widget-info.component";
import {ClinicShortInfoComponent} from "../../components/clinic-short-info/clinic-short-info.component";
import {GdprTermPlaceholderComponent} from "../../components/gdpr-term-placeholder/gdpr-term-placeholder.component";
import {ItemFinderComponent} from "../../components/item-finder/item-finder.component";
import {EditArticleComponent} from "../../components/edit-article/edit-article.component";
import {CategoryTreeComponent} from "../../components/category-tree/category-tree.component";
import {GalleryComponent} from "../../components/gallery/gallery.component";
import {FullPictureComponent} from "../../components/full-picture/full-picture.component";
import {CategoryPickerComponent} from "../../components/category-picker/category-picker.component";
import {CategorySelectMenuComponent} from "../../components/category-select-menu/category-select-menu.component";
import {
  InformationObligationPlaceholderComponent
} from "../../components/information-obligation-placeholder/information-obligation-placeholder.component";
import {
  GenerateInformationObligationComponent
} from "../../components/generate-information-obligation/generate-information-obligation.component";
import {
  KlinikaxpReservationDetailsModalComponent
} from "../../components/klinikaxp-reservation-details-modal/klinikaxp-reservation-details-modal.component";
import {QuillModule} from "ngx-quill";
import {
  VetClinicReportModalComponent
} from "../../components/vet-clinic-report-modal/vet-clinic-report-modal.component";
import {LeadDetailsComponent} from "../../components/lead-details/lead-details.component";
import {InvoiceDetailsComponent} from "../../components/invoice-details/invoice-details.component";
import {
  DataPickerForAdditionalKxpResTimeComponent
} from "../../components/data-picker-for-additional-kxp-res-time/data-picker-for-additional-kxp-res-time.component";
import {
  ClinicAdvancedSettingsComponent
} from "../../components/clinic-advanced-settings/clinic-advanced-settings.component";
import {SafeHtmlPipe} from "../../pipes/safe-html.pipe";
import {CustomComponent} from "../../components/custom/custom.component";
import {
  VetClinicCustomModalComponent
} from "../../components/vet-clinic-custom-modal/vet-clinic-custom-modal.component";
import {
  VetineoConfigurationCheckComponent
} from "../../components/vetineo-configuration-check/vetineo-configuration-check.component";
import {BecomeAmbasadorModalComponent} from "../../components/become-ambasador-modal/become-ambasador.modal.component";
import {SmsSettingsModalComponent} from "../../components/sms-settings-modal/sms-settings-modal.component";
import {LabTestDataForUserComponent} from "../../components/lab-test-data-for-user/lab-test-data-for-user.component";
import {EditAppUserComponent} from "../../components/edit-app-user/edit-app-user.component";
import {EditAmbassadorComponent} from "../../components/edit-ambassador/edit-ambassador.component";
import {HtmlInputComponent} from "../../components/html-input/html-input.component";
import {SelectDateComponent} from "../../components/select-date/select-date.component";
import {AdvancedDaySettingComponent} from "../../components/advanced-day-setting/advanced-day-setting.component";
import {
  AdvancedListReservationJsonElementComponent
} from "../../components/advanced-list-reservation-json-element/advanced-list-reservation-json-element.component";
import {
  SelectSmsCrmModuleExpirationDateComponent
} from "../../components/select-sms-crm-module-expiration-date/select-sms-crm-module-expiration-date.component";
import {GenericSelectDateComponent} from 'src/app/components/generic-select-date/generic-select-date.component';
import {ChooseUserClinicComponent} from "../../components/choose-user-clinic-component/choose-user-clinic.component";
import {
  EditVetDoctorVetVisitTypeComponent
} from "../../components/edit-vet-doctor-vet-visit-type/edit-vet-doctor-vet-visit-type.component";
import {
  EditVetineoVisitTypeBundleComponent
} from "../../components/edit-vetineo-visit-type-bundle/edit-vetineo-visit-type-bundle.component";
import {
  SelectMultipleDoctorsComponent
} from "../../components/select-multiple-doctors/select-multiple-doctors.component";
import {
  VetDoctorVisitTypeImporterComponent
} from "../../components/vet-doctor-visit-type-importer/vet-doctor-visit-type-importer.component";
import {
  ListVisitTypesDetailsComponent
} from "../../components/list-visit-types-details/list-visit-types-details.component";
import {EditCarePlanServiceComponent} from "../../components/edit-care-plan-service/edit-care-plan-service.component";
import {EditUserCarePlanComponent} from "../../components/edit-user-care-plan/edit-user-care-plan.component";
import {
  ClientUserCarePlanSettingsComponent
} from "../../components/client-user-care-plan-settings/client-user-care-plan-settings.component";
import {
  ChangeLinkContactDataComponent
} from "../../components/change-link-contact-data/change-link-contact-data.component";
import {
  AdditionUserVetcodesDetailsComponent
} from "../../components/addition-user-vetcodes-details/addition-user-vetcodes-details.component";
import {
  PartnerProductDetailsComponent
} from "../../components/partner-product-details/partner-product-details.component";
import {
  EditProductRecommendationComponent
} from "../../components/edit-product-recommendation/edit-product-recommendation.component";
import {PartnerProductSearchComponent} from "../../components/partner-product-search/partner-product-search.component";
import {UserFinderComponent} from "../../components/user-finder/user-finder.component";
import {
  PartnerShopOrderDetailsComponent
} from "../../components/partner-shop-order-details/partner-shop-order-details.component";
import {
  RecommendationDetailsCsvComponent
} from 'src/app/components/recommendation-details-csv/recommendation-details-csv.component';
import {CartSummaryComponent} from 'src/app/components/cart-summary/cart-summary.component';
import {EditPartnerShopComponent} from "../../components/edit-partner-shop/edit-partner-shop.component";
import {
  PartnerProductCategoriesFilterComponent
} from "../../components/partner-product-categories-filter/partner-product-categories-filter.component";
import {
  ProductRecommendationConfiguratorComponent
} from "../../components/product-recommendation-configurator/product-recommendation-configurator.component";
import {
  VetPlanetCategoryProductModalComponent
} from "../../components/vet-planet-category-product-modal/vet-planet-category-product-modal.component";
import {
  EditCarePlanServiceGroupTypeComponent
} from "../../components/edit-care-plan-service-group-type/edit-care-plan-service-group-type.component";
import {
  UserCarePlanServicesComponent
} from "../../components/user-care-plan-services/user-care-plan-services.component";
import {
  UserCarePlanServicesModalComponent
} from "../../components/user-care-plan-services-modal/user-care-plan-services-modal.component";
import {ResultChartComponent} from "../../components/result-chart/result-chart.component";
import {
  ScheduledEmailsDetailsComponent
} from "../../components/scheduled-emails-details/scheduled-emails-details.component";
import {CheckUserVisitsComponent} from "../../components/check-user-visits/check-user-visits.component";
import {SelectDateModalComponent} from "../../components/select-date-modal/select-date-modal.component";
import {
  UserCarePlanUsageModalComponent
} from "../../components/user-care-plan-usage-modal/user-care-plan-usage-modal.component";
import {EditWellnessPlanModule} from "../../components/edit-welness-plan/edit-wellness-plan.module";
import {
  ConfigureVisitCategoriesForVetcodeModule
} from "../../components/configure-visit-categories-for-vetcode-modal/configure-visit-categories-for-vetcode.module";
import {
  VetineoVisitTypeBundleConfiguratorComponent
} from "../../components/vetineo-visit-type-bundle-configurator/vetineo-visit-type-bundle-configurator.component";
import {DragDropModule} from "@angular/cdk/drag-drop";
import {
  CancelationReasonPopoverComponent
} from 'src/app/components/cancelation-reason-popover/cancelation-reason-popover.component';
import {
  SimpleInnerHtmlModalComponent
} from 'src/app/components/simple-inner-html-modal/simple-inner-html-modal.component';
import {
  SelectVetDoctorVisitTypeTimeComponent
} from 'src/app/components/select-vet-doctor-visit-type-time/select-vet-doctor-visit-type-time.component';
import {
  VetDoctorVisitTypesInconsistenciesComponent
} from "../../components/vet-doctor-visit-types-inconsistencies/vet-doctor-visit-types-inconsistencies.component";
import {
  TextFieldConfirmModalComponent
} from "../../components/text-field-confirm-modal/text-field-confirm-modal.component";
import {SelectSpeciesModalComponent} from "../../components/select-species-modal/select-species-modal.component";
import {SelectMonthRangeComponent} from "../../components/select-month-range/select-month-range.component";

@NgModule({
  declarations: [SafePipe, FillPipe, MainMenuComponent, RefresherComponent, PageTopToolbarComponent, NotificationsPopoverComponent,
    CameraComponent, TwilioHomeComponent, ParticipantsComponent, RoomsComponent, SettingsComponent, DeviceSelectComponent,
    DataGridComponent, AddUserComponent, EditUserComponent, EditAppUserComponent, ChangeComponent, VImageDropComponent,
    FilesPreviewComponent, FilesDetailsPreviewerComponent, DataGridActionButtonsMenuComponent, EditClientComponent, EditPartnerBannerComponent, EditPartnerComponent, EditLeadComponent, LeadAgreementComponent,
    TranslationPipe, OrderDetailsComponent, ImportClinicComponent, ProcessSettlementReportComponent, VMessageComponent, SelectClientComponent,
    OrderSettlementItemsListComponent, VetineoHeaderComponent, TranslateOfferType, GenerateTermsComponent, TermPlaceholderComponent, RefundDetailsComponent,
    SettlementItemDetailsComponent, AddP24RegistrationDataComponent, NotFoundDataComponent, ResetPwdComponent, ClinicInfoEditComponent, ClinicTeamEditComponent,
    ClinicTimetableEditComponent, VImageEditorComponent, VImageManagerComponent, VetDoctorDataEditorComponent, ReservationJsonElementComponent,
    ListReservationJsonElementComponent, KlinikaxpPaymentModalComponent, LabDataEditComponent, AcceptRefundComponent, ComponentTitleComponent, SelectYearAndMonthComponent,
    EditNextVisitReminderSettingsComponent, NextVisitReminderVisitTypeComponent, RemindersForUserComponent, WidgetInfoComponent, ClinicShortInfoComponent, GdprTermPlaceholderComponent,
    ItemFinderComponent, EditArticleComponent, CategoryTreeComponent, GalleryComponent, FullPictureComponent, CategoryPickerComponent, CategorySelectMenuComponent,
    InformationObligationPlaceholderComponent, GenerateInformationObligationComponent, KlinikaxpReservationDetailsModalComponent, VetClinicReportModalComponent,
    LeadDetailsComponent, InvoiceDetailsComponent, DataPickerForAdditionalKxpResTimeComponent, ClinicAdvancedSettingsComponent, CustomComponent, SafeHtmlPipe,
    VetClinicCustomModalComponent, LabTestDataForUserComponent, BecomeAmbasadorModalComponent, EditAmbassadorComponent, VetineoConfigurationCheckComponent,
    SmsSettingsModalComponent, SelectDateComponent, AdvancedDaySettingComponent, AdvancedListReservationJsonElementComponent,
    HtmlInputComponent, SelectSmsCrmModuleExpirationDateComponent, GenericSelectDateComponent, ChooseUserClinicComponent,
    EditVetDoctorVetVisitTypeComponent, EditVetineoVisitTypeBundleComponent, SelectMultipleDoctorsComponent, VetDoctorVisitTypeImporterComponent,
    ListVisitTypesDetailsComponent, EditUserCarePlanComponent, EditCarePlanServiceComponent, ClientUserCarePlanSettingsComponent, ChangeLinkContactDataComponent, AdditionUserVetcodesDetailsComponent,
    PartnerProductDetailsComponent, EditProductRecommendationComponent, PartnerProductSearchComponent, UserFinderComponent, PartnerShopOrderDetailsComponent,
    RecommendationDetailsCsvComponent, CartSummaryComponent, EditPartnerShopComponent, PartnerProductCategoriesFilterComponent, ProductRecommendationConfiguratorComponent,
    VetPlanetCategoryProductModalComponent, UserCarePlanServicesComponent, UserCarePlanServicesModalComponent, ResultChartComponent, EditCarePlanServiceGroupTypeComponent, ScheduledEmailsDetailsComponent, CheckUserVisitsComponent,
    SelectDateModalComponent, UserCarePlanUsageModalComponent, VetineoVisitTypeBundleConfiguratorComponent, CancelationReasonPopoverComponent, SimpleInnerHtmlModalComponent,
    SelectVetDoctorVisitTypeTimeComponent, VetDoctorVisitTypesInconsistenciesComponent, TextFieldConfirmModalComponent, SelectSpeciesModalComponent, SelectMonthRangeComponent],
  exports: [SafePipe, FillPipe, MainMenuComponent, RefresherComponent,
    CameraComponent, TwilioHomeComponent, ParticipantsComponent, RoomsComponent, SettingsComponent, DeviceSelectComponent,
    PageTopToolbarComponent, NotificationsPopoverComponent, DataGridComponent, AddUserComponent, EditUserComponent, EditAppUserComponent, ChangeComponent, VImageDropComponent,
    FilesPreviewComponent, FilesDetailsPreviewerComponent, DataGridActionButtonsMenuComponent, EditClientComponent, EditPartnerBannerComponent, EditPartnerComponent, EditLeadComponent,
    LeadAgreementComponent, TranslationPipe, OrderDetailsComponent, ImportClinicComponent, ProcessSettlementReportComponent, VMessageComponent, SelectClientComponent,
    OrderSettlementItemsListComponent, VetineoHeaderComponent, TranslateOfferType, GenerateTermsComponent, TermPlaceholderComponent, RefundDetailsComponent,
    SettlementItemDetailsComponent, AddP24RegistrationDataComponent, NotFoundDataComponent, ResetPwdComponent, ClinicInfoEditComponent, ClinicTeamEditComponent,
    ClinicTimetableEditComponent, VImageEditorComponent, VImageManagerComponent, VetDoctorDataEditorComponent, ReservationJsonElementComponent,
    ListReservationJsonElementComponent, KlinikaxpPaymentModalComponent, LabDataEditComponent, AcceptRefundComponent, ComponentTitleComponent, SelectYearAndMonthComponent,
    EditNextVisitReminderSettingsComponent, NextVisitReminderVisitTypeComponent, RemindersForUserComponent, WidgetInfoComponent, ClinicShortInfoComponent, GdprTermPlaceholderComponent,
    ItemFinderComponent, EditArticleComponent, CategoryTreeComponent, GalleryComponent, FullPictureComponent, CategoryPickerComponent,
    CategorySelectMenuComponent, InformationObligationPlaceholderComponent, GenerateInformationObligationComponent, KlinikaxpReservationDetailsModalComponent, VetClinicCustomModalComponent,
    VetineoConfigurationCheckComponent, SmsSettingsModalComponent,
    VetClinicReportModalComponent, LeadDetailsComponent, InvoiceDetailsComponent, LabTestDataForUserComponent, ClinicAdvancedSettingsComponent, SafeHtmlPipe, CustomComponent,
    HtmlInputComponent,
    BecomeAmbasadorModalComponent, EditAmbassadorComponent, SelectDateComponent, AdvancedDaySettingComponent, AdvancedListReservationJsonElementComponent,
    SelectSmsCrmModuleExpirationDateComponent, GenericSelectDateComponent, ChooseUserClinicComponent,
    EditVetDoctorVetVisitTypeComponent, EditVetineoVisitTypeBundleComponent, SelectMultipleDoctorsComponent, VetDoctorVisitTypeImporterComponent, ListVisitTypesDetailsComponent,
    EditUserCarePlanComponent, EditCarePlanServiceComponent, ClientUserCarePlanSettingsComponent, ChangeLinkContactDataComponent, AdditionUserVetcodesDetailsComponent,
    PartnerProductDetailsComponent, EditProductRecommendationComponent, PartnerProductSearchComponent, UserFinderComponent, PartnerShopOrderDetailsComponent, RecommendationDetailsCsvComponent,
    CartSummaryComponent, EditPartnerShopComponent, PartnerProductCategoriesFilterComponent, ProductRecommendationConfiguratorComponent, VetPlanetCategoryProductModalComponent,
    UserCarePlanServicesComponent, UserCarePlanServicesModalComponent, ResultChartComponent, EditCarePlanServiceGroupTypeComponent, ScheduledEmailsDetailsComponent, CheckUserVisitsComponent,
    SelectDateModalComponent, UserCarePlanUsageModalComponent, VetineoVisitTypeBundleConfiguratorComponent, CancelationReasonPopoverComponent, SimpleInnerHtmlModalComponent,
    SelectVetDoctorVisitTypeTimeComponent, VetDoctorVisitTypesInconsistenciesComponent, TextFieldConfirmModalComponent, SelectSpeciesModalComponent, SelectMonthRangeComponent],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    NgxDropzoneModule,
    QuillModule,
    EditWellnessPlanModule,
    ConfigureVisitCategoriesForVetcodeModule,
    DragDropModule
  ]
})
export class VetineoComponentsModule {
}
